import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';


@Injectable()
export class Combo2Service {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/combo2';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }


    partycodeCombo(): Promise<any> {
        const url = `${this.Url}/partycodeCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    purchasePartyCombo(): Promise<any> {
        const url = `${this.Url}/purchasePartyCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
   
    brandCombo(): Promise<any> {
        const url = `${this.Url}/brandCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     typeCombo(): Promise<any> {
        const url = `${this.Url}/typeCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     styleCombo(): Promise<any> {
        const url = `${this.Url}/styleCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     fitCombo(): Promise<any> {
        const url = `${this.Url}/fitCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     colorCombo(): Promise<any> {
        const url = `${this.Url}/colorCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

     qualityCombo(): Promise<any> {
        const url = `${this.Url}/qualityCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    
     finyearCombo(): Promise<any> {
        const url = `${this.Url}/finyearCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    varietyStyleCombo(): Promise<any> {
        const url = `${this.Url}/varietyStyleCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    partyVarietyCombo(query: any): Promise<any> {

        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/partyVarietyCombo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);

    }
    varietyStylePoCombo(query: any): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/varietyStylePoCombo`;
        return this.http
            .get(url,options)
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    styleMasterCombo(): Promise<any> {
        const url = `${this.Url}/styleMasterCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    
     seasonCombo(): Promise<any> {
        const url = `${this.Url}/seasonCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    
     agentCombo(): Promise<any> {
        const url = `${this.Url}/agentCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    
     partyCombo(): Promise<any> {
        const url = `${this.Url}/partyCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
        
     coreDesignCombo(): Promise<any> {
        const url = `${this.Url}/coreDesignCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    designCombo(): Promise<any> {
        const url = `${this.Url}/designCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    newDesignCombo(): Promise<any> {
        const url = `${this.Url}/newDesignCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
   
   
    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/combo2.service.ts